<template>
    <div class="collapsible-filter-panel-group">
        <collapsible-filter-panel
            v-for="(panel, index) in panels"
            :key="index"
            :id="panel.id"
            :title="panel.title"
            :type="panel.type"
            :filters="panel.filters"
            :accordion="groupId"
            :selected-filters="panel.selectedFilters"
            @update-selected-filters="updateSelectedFilters"
        />
    </div>
</template>

<script>
    import CollapsibleFilterPanel from '../CollapsibleFilterPanel/CollapsibleFilterPanel';

    export default {
        name: 'collapsible-filter-panel-group',

        components: { CollapsibleFilterPanel },

        props: {
            groupId: {
                type: String,
                required: true,
            },

            panels: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                selectedFilters: () => this.panels.reduce((acc, panel) => {
                    acc[panel.id] = panel.selectedFilters;
                    return acc;
                }, {}),
            };
        },

        methods: {
            /**
             * Update the selected filters for the given ID.
             *
             * @param {*} val The value to update.
             * @param {*} id  The ID of the panel that is updating.
             */
            updateSelectedFilters(val, id) {
                this.selectedFilters[id] = val;
                this.$emit('update-selected-filters', val, id);
            },
        },
    };
</script>

<style lang="scss" scoped>
    .collapsible-filter-panel-group {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
        position: relative;
        flex-grow: 1;
    }

    // Double class name for specificity
    ::v-deep .content-container.content-container {
        position: static;
    }
</style>
